import React, { FC } from 'react';
import clsx from 'clsx';
import Swiper from '../custom-swiper/CustomSwiper';

interface SwiperWrapperProps {
  children: React.ReactNode;
  className?: string;
}

const SwiperWrapper: FC<SwiperWrapperProps> = ({ children, className }) => {
  return (
    <div
      className={clsx(
        'relative flex h-[360px] w-full max-w-full',
        'md:h-[400px]',
        'lg:h-[400px]',
        '2xl:h-[480px]',
        className,
      )}
    >
      <Swiper
        spaceBetween={16}
        slidesPerView={'auto'}
        mousewheel={true}
        scrollbar={true}
        classNamesSwiperSlides={clsx(
          'first:ml-2.5 last:mr-2.5',
          'sm:first:ml-4  sm:last:mr-4',
          'md:first:ml-0  md:last:mr-8',
          'lg:first:ml-0 lg:ml-0 lg:last:mr-0',
        )}
      >
        {children}
      </Swiper>
    </div>
  );
};

export default SwiperWrapper;
